import { CreateColumn } from '../../../../Services/agGrid/createColumn';

export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow1: props.DeleteNewRow1,
        RestoreRow1: props.RestoreRow1,
        gridRef1: props.gridRef1,
        rowData1: props.rowData1,
        selectedRowNosRef1: props.selectedRowNosRef1,
        lastCheckedIndexRef1: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 80,
      rowDrag: (params) => params.data?.deleteYn !== 'Y',
    }),

    // 숨김 컬럼
    CreateColumn(
      'CustCd',
      '사업장코드',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
    CreateColumn(
      'aiMessageCd',
      '보이스 체크 메세지 코드',
      'left',
      120,
      false,
      false,
      true,
      'text',
      { minWidth: 120 }
    ),
    CreateColumn('gubun', '구분', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),
    CreateColumn('aiLan', '언어', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),

    CreateColumn(
      'message',
      '보이스 체크 내용',
      'left',
      200,
      true,
      true,
      false,
      'text',
      {
        flex: 1,
        sortable: false,
        cellClassRules: {
          'required-cell': (params) =>
            !params.value || params.value.trim() === '',
        },
        cellEditorParams: {
          maxLength: 100,
        },
      }
    ),
  ];
};

export const getColumnDefs2 = (props) => {
  return [
    CreateColumn(
      'custCd',
      '사업장코드',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        minWidth: 200,
      }
    ),

    CreateColumn(
      'custNm',
      '사업장명',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        minWidth: 200,
      }
    ),

    CreateColumn(
      'createDt',
      '일자',
      'center',
      120,
      false,
      false,
      true,
      'text',
      {
        minWidth: 120,
        rowGroup: true,
        enableRowGroup: true,
      }
    ),

    CreateColumn('name', '이름', 'left', 120, false, false, false, 'text', {
      minWidth: 120,
      cellClass: 'none-editable-cell',
    }),

    CreateColumn(
      'voiceAddress',
      '파일이름',
      'left',
      240,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        cellClass: 'none-editable-cell',
      }
    ),

    CreateColumn(
      'play',
      '녹음듣기',
      'center',
      120,
      false,
      false,
      false,
      'button',
      {
        buttonText: '녹음듣기',
        buttonCondition: (params) => !params.node?.group,
        buttonClickHandler: (params) => props.SearchLogic2?.(params.data),
        pinned: 'right',
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
};

export default columnDefs;
